try{
(function(){
  'use strict';

  var existing=window.NNBatchRecord;
  if(existing&&existing.__nnbr){
    if(typeof existing.init==='function')existing.init(document);
    return;
  }

  var records=[];
  var activeRecord=null;
  var lastFocus=null;
  var closeTimer=0;
  var idSequence=0;
  var scrollState=null;
  var redirectingFocus=false;

  function toArray(nodes){return Array.prototype.slice.call(nodes||[]);}

  function matches(node,selector){
    if(!node||node.nodeType!==1)return false;
    var method=node.matches||node.msMatchesSelector||node.webkitMatchesSelector;
    return Boolean(method&&method.call(node,selector));
  }

  function closest(node,selector){
    while(node&&node!==document){
      if(matches(node,selector))return node;
      node=node.parentElement;
    }
    return null;
  }

  function nodesWithin(scope,selector){
    var found=[];
    if(scope&&scope.nodeType===1&&matches(scope,selector))found.push(scope);
    if(scope&&scope.querySelectorAll)found=found.concat(toArray(scope.querySelectorAll(selector)));
    return found;
  }

  function recordForDialog(dialog){
    for(var index=0;index<records.length;index+=1){
      if(records[index].dialog===dialog)return records[index];
    }
    return null;
  }

  function recordForId(id){
    var normalized=String(id||'').replace(/^#/,'').split(/\s+/)[0];
    if(!normalized)return null;
    for(var index=0;index<records.length;index+=1){
      if(records[index].dialog.id===normalized)return records[index];
    }
    return null;
  }

  function targetId(trigger){
    if(!trigger)return '';
    return trigger.getAttribute('data-nnbr-target')||trigger.getAttribute('data-nnbr-open')||trigger.getAttribute('aria-controls')||'';
  }

  function recordForTrigger(trigger){
    var explicit=recordForId(targetId(trigger));
    if(explicit)return explicit;
    var containingDialog=closest(trigger,'[data-nnbr-dialog]');
    if(containingDialog)return recordForDialog(containingDialog);
    return records.length===1?records[0]:null;
  }

  function recordForEvidenceNode(node){
    var dialog=closest(node,'[data-nnbr-dialog]');
    if(dialog)return recordForDialog(dialog);
    var owner=closest(node,'[data-nnbr-section]');
    if(owner){
      var product=owner.getAttribute('data-nnbr-product')||'';
      var lot=owner.getAttribute('data-nnbr-lot')||'';
      for(var index=0;index<records.length;index+=1){
        var candidate=records[index].dialog;
        if((!product||candidate.getAttribute('data-nnbr-product')===product)&&(!lot||candidate.getAttribute('data-nnbr-lot')===lot))return records[index];
      }
    }
    return records.length===1?records[0]:null;
  }

  function resolveRecord(target){
    if(target&&target.dialog&&target.dialog.nodeType===1)return target;
    if(typeof target==='string')return recordForId(target);
    if(target&&target.nodeType===1){
      if(matches(target,'[data-nnbr-dialog]'))return recordForDialog(target);
      if(matches(target,'[data-nnbr-open]'))return recordForTrigger(target);
      var dialog=closest(target,'[data-nnbr-dialog]');
      if(dialog)return recordForDialog(dialog);
    }
    return records.length===1?records[0]:null;
  }

  function payloadFor(record){
    var dialog=record&&record.dialog;
    return {
      product:dialog?dialog.getAttribute('data-nnbr-product')||'':'',
      state:dialog?dialog.getAttribute('data-nnbr-state')||'':'',
      provider:dialog?dialog.getAttribute('data-nnbr-provider')||'':'',
      lot:dialog?dialog.getAttribute('data-nnbr-lot')||'':''
    };
  }

  function track(name,record){
    var detail=payloadFor(record);
    try{window.dispatchEvent(new CustomEvent('nn:'+name,{detail:detail}));}catch(eventError){}
    if(Array.isArray(window.dataLayer)){
      window.dataLayer.push({
        event:'nn_'+name,
        product:detail.product,
        state:detail.state,
        provider:detail.provider,
        lot:detail.lot
      });
    }
  }

  function focusable(container){
    if(!container)return [];
    return toArray(container.querySelectorAll('a[href],area[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),details>summary:first-of-type,[contenteditable="true"],[tabindex]:not([tabindex="-1"])')).filter(function(node){
      if(node.hidden||node.getAttribute('aria-hidden')==='true'||node.closest&&node.closest('[hidden]'))return false;
      var style=window.getComputedStyle?window.getComputedStyle(node):null;
      if(style&&(style.visibility==='hidden'||style.display==='none'))return false;
      return node.getClientRects().length>0;
    });
  }

  function focusInitial(record){
    if(!record||record!==activeRecord)return;
    var dialog=record.dialog;
    var target=dialog.querySelector('[data-nnbr-initial-focus]')||dialog.querySelector('[data-nnbr-close]');
    if(!target)target=focusable(dialog)[0]||record.focusRoot;
    try{target.focus({preventScroll:true});}catch(focusError){try{target.focus();}catch(ignoreError){}}
  }

  function triggersFor(record){
    return toArray(document.querySelectorAll('[data-nnbr-open]')).filter(function(trigger){
      var id=targetId(trigger).replace(/^#/,'').split(/\s+/)[0];
      if(id)return id===record.dialog.id;
      return records.length===1;
    });
  }

  function setTriggerState(record,expanded){
    triggersFor(record).forEach(function(trigger){trigger.setAttribute('aria-expanded',String(Boolean(expanded)));});
  }

  function setBackgroundInert(active){
    toArray(document.body.children).forEach(function(node){
      if(matches(node,'[data-nnbr-dialog]')||node.tagName==='SCRIPT'||node.tagName==='STYLE'||node.tagName==='LINK'||node.tagName==='TEMPLATE')return;
      if(active){
        if(!node.inert&&!node.hasAttribute('inert')){
          node.setAttribute('data-nnbr-inerted','');
          node.inert=true;
        }
        if(!node.hasAttribute('aria-hidden')){
          node.setAttribute('data-nnbr-aria-hidden','');
          node.setAttribute('aria-hidden','true');
        }
      }else{
        if(node.hasAttribute('data-nnbr-inerted')){
          node.inert=false;
          node.removeAttribute('data-nnbr-inerted');
        }
        if(node.hasAttribute('data-nnbr-aria-hidden')){
          node.removeAttribute('aria-hidden');
          node.removeAttribute('data-nnbr-aria-hidden');
        }
      }
    });
  }

  function lockScroll(){
    if(scrollState)return;
    var body=document.body;
    scrollState={
      overflow:body.style.getPropertyValue('overflow'),
      overflowPriority:body.style.getPropertyPriority('overflow'),
      ownedLock:!body.classList.contains('nn-lock')
    };
    body.classList.add('nnbr-open','nn-lock');
    body.style.setProperty('overflow','hidden','important');
  }

  function unlockScroll(){
    if(!scrollState)return;
    var body=document.body;
    if(scrollState.overflow)body.style.setProperty('overflow',scrollState.overflow,scrollState.overflowPriority||'');
    else body.style.removeProperty('overflow');
    body.classList.remove('nnbr-open');
    if(scrollState.ownedLock&&!body.classList.contains('nn-cart-open')&&!body.classList.contains('nn-search-open')&&!body.classList.contains('nn-menu-open'))body.classList.remove('nn-lock');
    scrollState=null;
  }

  function closeCompetingLayers(){
    if(window.NNCart&&typeof window.NNCart.close==='function')window.NNCart.close(false);
    if(window.NNSearch&&typeof window.NNSearch.close==='function')window.NNSearch.close(false);
    if(window.NNMenu&&typeof window.NNMenu.close==='function')window.NNMenu.close();
  }

  function openRecord(record,trigger){
    if(!record||!record.dialog||!document.body.contains(record.dialog))return false;
    if(activeRecord===record){
      focusInitial(record);
      return true;
    }
    if(activeRecord)closeRecord(false,true);

    closeCompetingLayers();
    window.clearTimeout(closeTimer);
    closeTimer=0;

    activeRecord=record;
    lastFocus=trigger&&trigger.nodeType===1?trigger:document.activeElement;
    record.dialog.hidden=false;
    record.dialog.inert=false;
    record.dialog.setAttribute('aria-hidden','false');
    setTriggerState(record,true);
    setBackgroundInert(true);
    lockScroll();

    window.requestAnimationFrame(function(){
      if(activeRecord!==record)return;
      record.dialog.classList.add('is-open');
      focusInitial(record);
    });
    track('batch_record_open',record);
    return true;
  }

  function closeRecord(restoreFocus,immediate){
    if(!activeRecord)return false;
    var record=activeRecord;
    var restoreTarget=lastFocus;
    activeRecord=null;
    lastFocus=null;
    window.clearTimeout(closeTimer);
    closeTimer=0;

    record.dialog.classList.remove('is-open');
    record.dialog.setAttribute('aria-hidden','true');
    record.dialog.inert=true;
    setTriggerState(record,false);
    setBackgroundInert(false);
    unlockScroll();

    var hide=function(){
      if(activeRecord!==record)record.dialog.hidden=true;
    };
    if(immediate)hide();
    else closeTimer=window.setTimeout(hide,420);

    if(restoreFocus!==false&&restoreTarget&&document.contains(restoreTarget)&&!restoreTarget.disabled){
      window.requestAnimationFrame(function(){
        try{restoreTarget.focus({preventScroll:true});}catch(focusError){try{restoreTarget.focus();}catch(ignoreError){}}
      });
    }
    return true;
  }

  function initializeDialog(dialog,scope){
    var current=recordForDialog(dialog);
    if(current)return current;

    if(!dialog.id){
      idSequence+=1;
      dialog.id='NNBatchRecordDialog-'+idSequence;
    }
    var duplicate=recordForId(dialog.id);
    if(duplicate&&duplicate.dialog!==dialog)destroyRecord(duplicate);

    var origin=closest(dialog,'.shopify-section')||(scope&&scope.nodeType===1?scope:null);
    var focusRoot=dialog.querySelector('[data-nnbr-panel]')||dialog;
    if(!dialog.hasAttribute('role')&&!focusRoot.hasAttribute('role'))focusRoot.setAttribute('role','dialog');
    if(!dialog.hasAttribute('aria-modal')&&!focusRoot.hasAttribute('aria-modal'))focusRoot.setAttribute('aria-modal','true');
    if(!focusRoot.hasAttribute('tabindex'))focusRoot.setAttribute('tabindex','-1');

    dialog.classList.remove('is-open');
    dialog.setAttribute('aria-hidden','true');
    dialog.inert=true;
    dialog.hidden=true;

    var record={
      dialog:dialog,
      focusRoot:focusRoot,
      origin:origin,
      sectionId:origin&&origin.id?origin.id:''
    };
    records.push(record);
    document.body.appendChild(dialog);
    setTriggerState(record,false);
    return record;
  }

  function destroyRecord(record){
    if(!record)return;
    if(activeRecord===record)closeRecord(false,true);
    window.clearTimeout(closeTimer);
    closeTimer=0;
    var index=records.indexOf(record);
    if(index!==-1)records.splice(index,1);
    if(record.dialog&&record.dialog.parentNode)record.dialog.parentNode.removeChild(record.dialog);
  }

  function init(scope){
    var root=scope&&scope.querySelectorAll?scope:document;
    nodesWithin(root,'[data-nnbr-dialog]').forEach(function(dialog){initializeDialog(dialog,root);});
    return records.length;
  }

  function destroy(scope){
    var root=scope&&scope.nodeType===1?scope:null;
    var sectionId=root&&root.id?root.id:'';
    records.slice().forEach(function(record){
      if(!root||record.dialog===root||record.origin===root||(sectionId&&record.sectionId===sectionId))destroyRecord(record);
    });
  }

  function onClick(event){
    var source=closest(event.target,'[data-nnbr-source]');
    if(source){
      var sourceRecord=recordForEvidenceNode(source)||activeRecord;
      if(sourceRecord)track('batch_source_click',sourceRecord);
    }

    var opener=closest(event.target,'[data-nnbr-open]');
    if(opener){
      var openingRecord=recordForTrigger(opener);
      if(openingRecord){
        event.preventDefault();
        openRecord(openingRecord,opener);
      }
      return;
    }

    if(!activeRecord)return;
    var closeButton=closest(event.target,'[data-nnbr-close]');
    var scrim=closest(event.target,'[data-nnbr-scrim]');
    if((closeButton&&activeRecord.dialog.contains(closeButton))||(scrim&&activeRecord.dialog.contains(scrim))){
      event.preventDefault();
      closeRecord(true,false);
    }
  }

  function onKeydown(event){
    if(!activeRecord)return;
    if(event.key==='Escape'||event.key==='Esc'){
      event.preventDefault();
      event.stopImmediatePropagation();
      closeRecord(true,false);
      return;
    }
    if(event.key!=='Tab')return;

    var items=focusable(activeRecord.dialog);
    if(!items.length){
      event.preventDefault();
      activeRecord.focusRoot.focus();
      return;
    }
    var first=items[0];
    var last=items[items.length-1];
    if(event.shiftKey&&(document.activeElement===first||!activeRecord.dialog.contains(document.activeElement))){
      event.preventDefault();
      last.focus();
    }else if(!event.shiftKey&&(document.activeElement===last||!activeRecord.dialog.contains(document.activeElement))){
      event.preventDefault();
      first.focus();
    }
  }

  function onFocusIn(event){
    if(!activeRecord||activeRecord.dialog.contains(event.target)||redirectingFocus)return;
    redirectingFocus=true;
    focusInitial(activeRecord);
    window.setTimeout(function(){redirectingFocus=false;},0);
  }

  function onSectionLoad(event){init(event.target);}

  function onSectionUnload(event){destroy(event.target);}

  document.addEventListener('click',onClick);
  document.addEventListener('keydown',onKeydown,true);
  document.addEventListener('focusin',onFocusIn,true);
  document.addEventListener('shopify:section:load',onSectionLoad);
  document.addEventListener('shopify:section:unload',onSectionUnload);

  window.NNBatchRecord={
    __nnbr:'1.0.0',
    init:init,
    destroy:destroy,
    open:function(target,trigger){
      var record=resolveRecord(target);
      var opener=trigger||(target&&target.nodeType===1&&matches(target,'[data-nnbr-open]')?target:document.activeElement);
      return openRecord(record,opener);
    },
    close:function(restoreFocus){return closeRecord(restoreFocus,false);},
    isOpen:function(){return Boolean(activeRecord);}
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);},{once:true});
  else init(document);
})();
}catch(error){
  if(window.console&&console.error)console.error('[NO:NAME batch record]',error);
}
